import React, { useState } from "react";
import { useFirebase } from "../providers/firebase";
import { useAuthentication } from "../providers/authentication";
import PeoplePopupModal from "../components/PeoplePopupModal";

function FacultyInCharge() {
  const { facultyInCharge } = useFirebase();

  return (
    <div className="container">
      <h1>Faculty-in-Charge</h1>
      {facultyInCharge && (
        <div>
          <img
            src={facultyInCharge.imageUrl}
            alt={facultyInCharge.name}
            className="image"
          />
          {facultyInCharge.personalUrl ? (
            <h2>
              <a href={facultyInCharge.personalUrl} className="name">
                {facultyInCharge.name}
              </a>
            </h2>
          ) : (
            <h2 className="name">{facultyInCharge.name}</h2>
          )}
          <p className="position">{facultyInCharge.position}</p>
          <p className="department">{facultyInCharge.department}</p>
          <p className="school">{facultyInCharge.school}</p>
        </div>
      )}
    </div>
  );
}

function DoctoralScholars({ user }) {
  const { doctoralScholars, addPeople, deletePeople, editPeople, uploadImage } =
    useFirebase();
  const [isModalVisible, setModalVisible] = useState(false);
  const [defaultValue, setDefaultValue] = useState("");
  const [uploadedImage, setUploadedImage] = useState(null);

  const handleEdit = (data) => {
    setModalVisible(true);
    setDefaultValue(data);
  };

  const handleDelete = (id) => {
    deletePeople("doctoralScholars", id).then(() => window.location.reload());
  };

  const handleAdd = () => {
    setDefaultValue("");
    setUploadedImage(null);
    setModalVisible(true);
  };

  const handleCloseModal = () => setModalVisible(false);

  const handleSubmit = (value) => {
    if (uploadedImage) {
      uploadImage(uploadedImage).then((imageUrl) => {
        value.imageUrl = imageUrl;
        finalizeSubmit(value);
      });
    } else finalizeSubmit(value);
  };

  const finalizeSubmit = (value) => {
    if (defaultValue) {
      editPeople("doctoralScholars", defaultValue.id, value).then(() =>
        window.location.reload()
      );
    } else {
      addPeople(value, "doctoralScholars").then(() => window.location.reload());
    }
    setModalVisible(false);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setUploadedImage(file);
  };

  return (
    <div className="page">
      <h1 className="title">
        Doctoral Scholars {user && <button onClick={handleAdd}>Add</button>}
      </h1>
      <div className="grid">
        {doctoralScholars &&
          doctoralScholars.map((scholar, index) => (
            <div key={index} className="scholarCard">
              <img
                src={scholar.imageUrl}
                alt={scholar.name}
                className="scholarImage"
              />
              <div className="scholarDetails">
                <h2>
                  <a href={scholar.personalUrl || "#"} className="scholarName">
                    {scholar.name}
                  </a>
                </h2>
                <p>{scholar.researchArea}</p>
                {scholar.duration && <p>{scholar.duration}</p>}
                {user && (
                  <div className="actions">
                    <button onClick={() => handleEdit(scholar)}>Edit</button>
                    <button onClick={() => handleDelete(scholar.id)}>
                      Delete
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
      <PeoplePopupModal
        show={isModalVisible}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        defaultValue={defaultValue}
        onImageChange={handleImageChange}
      />
    </div>
  );
}

function PostGraduateStudents({ user }) {
  const {
    postGraduateStudents,
    addPeople,
    deletePeople,
    editPeople,
    uploadImage,
  } = useFirebase();
  const [isModalVisible, setModalVisible] = useState(false);
  const [defaultValue, setDefaultValue] = useState("");
  const [uploadedImage, setUploadedImage] = useState(null);

  const handleEdit = (data) => {
    setModalVisible(true);
    setDefaultValue(data);
  };

  const handleDelete = (id) => {
    deletePeople("postGraduateStudents", id).then(() => window.location.reload());
  };

  const handleAdd = () => {
    setDefaultValue("");
    setUploadedImage(null);
    setModalVisible(true);
  };

  const handleCloseModal = () => setModalVisible(false);

  const handleSubmit = (value) => {
    if (uploadedImage) {
      uploadImage(uploadedImage).then((imageUrl) => {
        value.imageUrl = imageUrl;
        finalizeSubmit(value);
      });
    } else finalizeSubmit(value);
  };

  const finalizeSubmit = (value) => {
    if (defaultValue) {
      editPeople("postGraduateStudents", defaultValue.id, value).then(() =>
        window.location.reload()
      );
    } else {
      addPeople(value, "postGraduateStudents").then(() =>
        window.location.reload()
      );
    }
    setModalVisible(false);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setUploadedImage(file);
  };

  return (
    <div className="page">
      <h1 className="title">
        Post Graduate Students {user && <button onClick={handleAdd}>Add</button>}
      </h1>
      <div className="grid">
        {postGraduateStudents &&
          postGraduateStudents.map((scholar, index) => (
            <div key={index} className="scholarCard">
              <img
                src={scholar.imageUrl}
                alt={scholar.name}
                className="scholarImage"
              />
              <div className="scholarDetails">
                <h2>
                  <a href={scholar.personalUrl || "#"} className="scholarName">
                    {scholar.name}
                  </a>
                </h2>
                <p>{scholar.researchArea}</p>
                {scholar.duration && <p>{scholar.duration}</p>}
                {scholar.degree && <p>{scholar.degree}</p>}
                {user && (
                  <div className="actions">
                    <button onClick={() => handleEdit(scholar)}>Edit</button>
                    <button onClick={() => handleDelete(scholar.id)}>
                      Delete
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
      <PeoplePopupModal
        show={isModalVisible}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        defaultValue={defaultValue}
        onImageChange={handleImageChange}
      />
    </div>
  );
}

function ProjectScholars({ user }) {
  const { projectScholars, addPeople, deletePeople, editPeople, uploadImage } =
    useFirebase();
  const [isModalVisible, setModalVisible] = useState(false);
  const [defaultValue, setDefaultValue] = useState("");
  const [uploadedImage, setUploadedImage] = useState(null);

  const handleEdit = (data) => {
    setModalVisible(true);
    setDefaultValue(data);
  };

  const handleDelete = (id) => {
    deletePeople("projectScholars", id).then(() => window.location.reload());
  };

  const handleAdd = () => {
    setDefaultValue("");
    setUploadedImage(null);
    setModalVisible(true);
  };

  const handleCloseModal = () => setModalVisible(false);

  const handleSubmit = (value) => {
    if (uploadedImage) {
      uploadImage(uploadedImage).then((imageUrl) => {
        value.imageUrl = imageUrl;
        finalizeSubmit(value);
      });
    } else finalizeSubmit(value);
  };

  const finalizeSubmit = (value) => {
    if (defaultValue) {
      editPeople("projectScholars", defaultValue.id, value).then(() =>
        window.location.reload()
      );
    } else {
      addPeople(value, "projectScholars").then(() => window.location.reload());
    }
    setModalVisible(false);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setUploadedImage(file);
  };

  return (
    <div className="page">
      <h1 className="title">
        Project Scholars {user && <button onClick={handleAdd}>Add</button>}
      </h1>
      <div className="grid">
        {projectScholars &&
          projectScholars.map((scholar, index) => (
            <div key={index} className="scholarCard">
              <img
                src={scholar.imageUrl}
                alt={scholar.name}
                className="scholarImage"
              />
              <div className="scholarDetails">
                <h2>
                  <a href={scholar.personalUrl || "#"} className="scholarName">
                    {scholar.name}
                  </a>
                </h2>
                <p>{scholar.researchArea}</p>
                {scholar.duration && <p>{scholar.duration}</p>}
                {scholar.degree && <p>{scholar.degree}</p>}
                {user && (
                  <div className="actions">
                    <button onClick={() => handleEdit(scholar)}>Edit</button>
                    <button onClick={() => handleDelete(scholar.id)}>
                      Delete
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
      <PeoplePopupModal
        show={isModalVisible}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        defaultValue={defaultValue}
        onImageChange={handleImageChange}
      />
    </div>
  );
}

/** ✅ NEW: Undergraduate Students */
function UnderGraduateStudents({ user }) {
  const {
    underGraduateStudents,
    addPeople,
    deletePeople,
    editPeople,
    uploadImage,
  } = useFirebase();

  const [isModalVisible, setModalVisible] = useState(false);
  const [defaultValue, setDefaultValue] = useState("");
  const [uploadedImage, setUploadedImage] = useState(null);

  const handleEdit = (data) => {
    setModalVisible(true);
    setDefaultValue(data);
  };

  const handleDelete = (id) => {
    deletePeople("underGraduateStudents", id).then(() =>
      window.location.reload()
    );
  };

  const handleAdd = () => {
    setDefaultValue("");
    setUploadedImage(null);
    setModalVisible(true);
  };

  const handleCloseModal = () => setModalVisible(false);

  const handleSubmit = (value) => {
    if (uploadedImage) {
      uploadImage(uploadedImage).then((imageUrl) => {
        value.imageUrl = imageUrl;
        finalizeSubmit(value);
      });
    } else finalizeSubmit(value);
  };

  const finalizeSubmit = (value) => {
    if (defaultValue) {
      editPeople("underGraduateStudents", defaultValue.id, value).then(() =>
        window.location.reload()
      );
    } else {
      addPeople(value, "underGraduateStudents").then(() =>
        window.location.reload()
      );
    }
    setModalVisible(false);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setUploadedImage(file);
  };

  return (
    <div className="page">
      <h1 className="title">
        Undergraduate Students {user && <button onClick={handleAdd}>Add</button>}
      </h1>

      <div className="grid">
        {underGraduateStudents &&
          underGraduateStudents.map((student, index) => (
            <div key={index} className="scholarCard">
              <img
                src={student.imageUrl}
                alt={student.name}
                className="scholarImage"
              />
              <div className="scholarDetails">
                <h2>
                  <a href={student.personalUrl || "#"} className="scholarName">
                    {student.name}
                  </a>
                </h2>

                {/* Keep same fields, or change as you like */}
                {student.researchArea && <p>{student.researchArea}</p>}
                {student.duration && <p>{student.duration}</p>}
                {student.degree && <p>{student.degree}</p>}

                {user && (
                  <div className="actions">
                    <button onClick={() => handleEdit(student)}>Edit</button>
                    <button onClick={() => handleDelete(student.id)}>
                      Delete
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>

      <PeoplePopupModal
        show={isModalVisible}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        defaultValue={defaultValue}
        onImageChange={handleImageChange}
      />
    </div>
  );
}

function People() {
  const { user } = useAuthentication();

  return (
    <div className="pastScholars-page-container">
      <div className="pastScholars-heading">People</div>
      <FacultyInCharge />
      <DoctoralScholars user={user} />
      <PostGraduateStudents user={user} />
      <ProjectScholars user={user} />
      <UnderGraduateStudents user={user} /> {/* ✅ added */}
    </div>
  );
}

export default People;

// Inline CSS
const style = `
.container {
  text-align: center;
  margin-bottom: 40px;
}
.image {
  width: 300px;
  height: 300px;
  object-fit: cover;
}
.name {
  font-size: 22px;
  font-weight: bold;
  color: black;
  text-decoration: underline;
}
.position, .department, .school {
  font-size: 16px;
  margin-top: 5px;
}
.page {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}
.title {
  color: #333;
  margin-bottom: 40px;
  font-size: 28px;
  font-weight: bold;
}
.grid {
  display: grid;
  gap: 30px;
  justify-content: center;
  grid-template-columns: repeat(2, 1fr);
}
.scholarCard {
  display: flex;
  align-items: center;
  padding: 15px;
}
.scholarImage {
  width: 150px;
  height: 160px;
  margin-right: 20px;
}
.scholarDetails {
  display: flex;
  flex-direction: column;
}
.scholarName {
  font-weight: bold;
  font-size: 25px;
  color: red;
  text-decoration: underline;
}
.actions button {
  margin-right: 10px;
}

/* Media query for mobile screens */
@media (max-width: 768px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
`;

document.head.insertAdjacentHTML("beforeend", `<style>${style}</style>`);

